//********* TUTORIALS *********//
import * as types from "../../actions/actionTypes";
import {getExportAIData, getActivePartIdsForFeatureArea} from "./aiFunctions";
import {getCurrentLayout} from "../appLayout";
import {setLocalStorageItem} from "../../misc/storageFunctions";
import {getCommonVisualizerType} from "../../config";
import {FEATURE_AREAS} from "./aiFeatureAreasConstants";

export const setAILoading = (aiLoading) => ({
  type: types.SET_AI_LOADING,
  payload: {aiLoading}
});

export const setAIWaitingId = (aiWaitingId) => {
  setLocalStorageItem("aiWaitingId", aiWaitingId);
  return {
    type: types.SET_AI_WAITING_ID,
    payload: {aiWaitingId}
  }
}

export const setAIResults = (aiResults) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_AI_RESULTS,
      payload: {aiResults}
    });
    const layout = getCurrentLayout();
    layout.updateLocalStorage();
  }
};

export const setLookAiImageOpened = (lookAiImageOpened) => ({
  type: types.SET_LOOK_AI_IMAGE_OPENED,
  payload: {lookAiImageOpened}
});

export const setAiUserFileBlobUrl = (aiUserFileBlobUrl) => ({
  type: types.SET_AI_USER_FILE_BLOB_URL,
  payload: {aiUserFileBlobUrl}
});

export const setLookAiRenderFinished = (lookAiRenderFinished) => ({
  type: types.SET_LOOK_AI_RENDER_FINIHSED,
  payload: {lookAiRenderFinished}
});

export const setLookAiWaitingBoxClicked = (lookAiWaitingBoxClicked) => ({
  type: types.SET_LOOK_AI_WAITING_BOX_CLICKED,
  payload: {lookAiWaitingBoxClicked}
});

export const setLookAiImageExpanded = (aiImageExpanded) => ({
  type: types.SET_LOOK_AI_IMAGE_EXPANDED,
  payload: {aiImageExpanded}
});

export const setLookAiExportData = (groupObjects, aiResults) => {
  return (dispatch, getState) => {
    const aiExportData = getExportAIData(getState().aiState, groupObjects, aiResults);
    dispatch({
      type: types.SET_LOOK_AI_EXPORT_DATA,
      payload: {aiExportData}
    })
  }
}

export const setLookAiImportData = (aiImportData) => {
  return (dispatch, getState) => {
    dispatch({
      type: types.SET_LOOK_AI_IMPORT_DATA,
      payload: {
        aiImportData,
        aiResults: aiImportData?.aiResults || getState().aiState.aiResults,
      }
    })
  }
}

export const setAiRenderOptions = (aiRenderOptions) => ({
  type: types.SET_AI_RENDER_OPTIONS,
  payload: aiRenderOptions
});

export const setAiFeatureAreas = (aiFeatureAreas) => ({
  type: types.SET_AI_FEATURE_AREAS,
  payload: aiFeatureAreas
});

export const setAiFeatureAreasUserModified = (aiFeatureAreasUserModified) => ({
  type: types.SET_AI_FEATURE_AREAS_USER_MODIFIED,
  payload: {aiFeatureAreasUserModified}
});

/**
 * Computes the default selected partIds for every AI feature area (Wet Area, Vanity Area)
 * based on what's currently active in the layout, and applies them - same logic as the
 * "select" branch of toggleFeatureArea in UiPopupAIContentFeaturesAreas.
 *
 * Only areas enabled in the global settings (aiAreasWetArea / aiAreasVanityArea, see
 * `settingKey` in FEATURE_AREAS) are checked by default - disabled ones are left empty.
 *
 * Called: (1) once getAIGlobalSettings first receives settings with aiFeatureAreaEnabled on,
 * and (2) every time UiPopupAIContentFeaturesAreas or LookAIPopupContent is opened, so the
 * defaults reflect whatever is currently on the canvas. Bails out on its own if the user has
 * already taken manual control (aiFeatureAreasUserModified), so callers don't need to guard it.
 */
export const setDefaultAiFeatureAreasGroups = () => {
  return (dispatch, getState) => {
    if (getCommonVisualizerType() !== "bathroom" || getState().aiState.aiFeatureAreasUserModified) {
      return;
    }
    const layout = getCurrentLayout();
    const aiRenderOptions = getState().aiState.aiRenderOptions;
    const aiFeatureAreas = FEATURE_AREAS.reduce((result, {featureArea, partIds, settingKey}) => {
      if (!aiRenderOptions[settingKey]) {
        result[featureArea] = [];
        return result;
      }
      const availablePartIds = partIds.filter(partId => layout?.getFeatureGroupByPartId(partId));
      result[featureArea] = getActivePartIdsForFeatureArea(availablePartIds, layout);
      return result;
    }, {});
    dispatch(setAiFeatureAreas(aiFeatureAreas));
  };
};

export const setGlobalSettingsRequested = (visualizerType) => {
  return (dispatch, getState) => {
    dispatch({
      type: types.SET_AI_GLOBAL_SETTINGS_REQUESTED,
      payload: {
        aiGlobalSettingsRequested: [...getState().aiState.aiGlobalSettingsRequested, visualizerType],
      }
    })
  }
};
